import * as React from "react";
const SvgAttachmentDownload = props => <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" style={{
  fillRule: "evenodd",
  clipRule: "evenodd",
  strokeLinejoin: "round",
  strokeMiterlimit: 2
}} viewBox="0 0 24 24" {...props}><circle cx={12} cy={12} r={12} style={{
    fill: "#fff"
  }} /><path d="M16.205 12.615 12 16.82l-4.205-4.205.773-.773 2.885 2.885V5h1.094v9.727l2.885-2.885.773.773ZM19 17.906H5V19h14v-1.094Z" style={{
    fill: "#425ef2",
    fillRule: "nonzero"
  }} /></svg>;
export { SvgAttachmentDownload as ReactComponent };
export default __webpack_public_path__ + "assets/svg/attachment-download1e5JoJq2UFFpiILd.svg";